import { useState, useEffect } from 'react';
import { getItemGroupList, deleteItemGroup } from 'helpers/backend_helper';
import { Common } from 'helpers/common';
import filterDataBySearch from 'Common/filterDataBySearch';

export const useItemGroupList = () => {
    const [allItemGroup, setAllItemGroup] = useState<any[]>([]);
    const [itemGroupList, setItemGroupList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const uiHelper = new Common();

    useEffect(() => {
        loadItemGroups(false);
    }, []);

    const loadItemGroups = async (reload: boolean) => {
        try {
            if (itemGroupList.length === 0 || reload) {
                const response = await getItemGroupList();
                if (response) {
                    setItemGroupList(response.data as never[]);
                    setAllItemGroup(response.data as never[]);
                }
            }
        } catch (error) {
            console.error('Error loading item groups:', error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDelete = async (itemGroupId: number) => {
        try {
            await deleteItemGroup(itemGroupId);
            setItemGroupList((prevList) => prevList.filter((itemGroup: any) => itemGroup.id !== itemGroupId));
            uiHelper.showSuccessMessage("Item Group has been deleted successfully.");
            return true;
        } catch (error) {
            console.error('Error deleting item group:', error);
            return false;
        }
    };

    const updateItemGroupList = (result: any, isEdit: boolean, itemGroupData: any) => {
        if (isEdit) {
            setItemGroupList((prevList) =>
                prevList.map((itemGroup: any) =>
                    itemGroup.id === itemGroupData.id ? { ...result } : { ...itemGroup }
                )
            );
        } else {
            setItemGroupList((prevList) => [{ ...result }, ...prevList]);
        }
    };

    const filterSearchData = (e: any) => {
        const search = e.target.value;
        const keysToSearch = ['group_name', 'description'];
        filterDataBySearch(allItemGroup, search, keysToSearch, setItemGroupList);
    };

    return {
        itemGroupList,
        isLoading,
        handleDelete,
        updateItemGroupList,
        filterSearchData
    };
};